<section class="flex flex-col w-full family-card-health">
  <go-back class="w-full mb-4 flex flex-start sm:hidden"></go-back>
  <div class="text-center pb-8 md:pb-20 header">
    <h1 class="outfit extra-bold pb-6 md:pb-8 heading-large">{{ familyCardHealth.title | translate }}</h1>
    <p class="paragraph-medium outfit font-normal">{{ familyCardHealth.subTitle | translate }}</p>
  </div>
  <div class="w-full flex flex-col justify-between items-start md:flex-row gap-8 pb-4">
    <div class="flex w-full justify-start lg:self-start md:justify-start items-center flex-col gap-10 sm:gap-4">
      <p
        class="paragraph-medium font-normal order-2 md:order-1 text-center md:text-justify inline-block outfit md:mb-12"
      >
        {{ familyCardHealth.details | translate }}
      </p>
      <div class="w-72 h-auto order-1 md:hidden">
        <img [src]="familyCardHealth.illustrationMobile" alt="" class="w-full block md:hidden object-cover" />
      </div>
      <korviu-button type="button" color="tertiary" (click)="learnMore()" class="w-full order-3">{{
        familyCardHealth.learnMore | translate
      }}</korviu-button>
    </div>
    <div class="w-full hidden md:flex justify-center self-stretch items-center">
      <img [src]="familyCardHealth.illustration" alt="" class="w-full hidden md:block object-cover" />
    </div>
  </div>
</section>
